module.exports = __webpack_public_path__ + "445a7b575b7d822f9eb86b9385a4a08f.mp3";


//////////////////
// WEBPACK FOOTER
// ./assets/sounds/owl-hoots/screech_owl_hoot.mp3
// module id = 4160
// module chunks = 0